import { render, staticRenderFns } from "./Chart2.vue?vue&type=template&id=ba31ace0&scoped=true"
import script from "./Chart2.vue?vue&type=script&lang=js"
export * from "./Chart2.vue?vue&type=script&lang=js"
import style0 from "./Chart2.vue?vue&type=style&index=0&id=ba31ace0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba31ace0",
  null
  
)

export default component.exports